import U2000Header from "./U2000Header";
import U2000Footer from "./U2000Footer";
import U2000BusyIndicator from "./U2000BusyIndicator";
import U2000VerticalMenu from "../U2000VerticalMenu";
import { Outlet, useLocation } from "react-router-dom";
import { useU3201GoogleCalendarOAuthReturnRedirect } from "../../../../u3201GoogleCalendar/U3201UseGoogleCalendarOAuthReturnRedirect";

import type { U2000MenuProps } from "./U2000Menu";
import type { U2000MenuModule } from "../../../menu/U2000Menu";
import { U2000Breadcrumb } from "../../breadcrumb/U2000Breadcrumb";
import { U2000FormLeaveGuardProvider } from "../../../context/formLeaveGuard/U2000FormLeaveGuardContext";
import { U2000LogicalUnitProvider } from "../../../context/logicalUnit/U2000LogicalUnitContext";
import { useU2000AuthContext } from "../../../context/auth/U2000UseAuthContext";
import { u2000IsLogicalUnitListPath } from "../../../tools/u2000IsLogicalUnitListPath";

const U2000WorkSpace: React.FC<U2000MenuProps> = () => {
  useU3201GoogleCalendarOAuthReturnRedirect();
  const { auth } = useU2000AuthContext();
  const location = useLocation();
  const menuData = (auth.menu ?? []) as U2000MenuModule[];
  // BL-0429 — breadcrumb masqué en mode liste
  const isListMode = u2000IsLogicalUnitListPath(location.pathname);

  return (
    <U2000FormLeaveGuardProvider>
      <div className="flex h-screen overflow-hidden">
        {/* Vertical Menu Sidebar — BL-0342 : auth.menu (filtré), pas le catalogue brut */}
        <U2000VerticalMenu menuData={menuData} />

        {/* Main Content Area */}
        <U2000LogicalUnitProvider>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <U2000Header />

          {/* BL-0429 — breadcrumb masqué en liste ; espace entre header et basic search */}
          {!isListMode ? (
            <div className="mt-2 ps-8">
              <U2000Breadcrumb />
            </div>
          ) : (
            <div className="pt-4" aria-hidden />
          )}

          <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
            {/*
              Conteneur à hauteur fixe (absolute inset-0) : le screen view ne grandit pas.
              - U3204 : h-full + scroll uniquement dans la liste de conversation
              - Autres UL longues : scroll dans ce viewport (pas le body / pas sous le footer)
            */}
            <div className="relative min-h-0 min-w-0 flex-1 overflow-hidden">
              <div className="absolute inset-0 flex flex-col overflow-y-auto">
                <Outlet />
              </div>
            </div>
          </main>

          <U2000Footer />
        </div>
      </U2000LogicalUnitProvider>

        <U2000BusyIndicator />
      </div>
    </U2000FormLeaveGuardProvider>
  );
};

export default U2000WorkSpace;
